import { recordEventCustomOnly, recordPage } from 'utilities/uTagging';

const PAGE_NAME = 'requierementsToBeClient';

export const doTagPage = () => {
    const customData = {
        sectionFamily: 'banking',
        sectionCategory: 'onboarding',
        sectionName: 'userOnboarding',
        interactionType: 'page',
        serviceType: 'onboarding',
        pageName: 'requirementsToBeClient',
    };

    recordPage(
        PAGE_NAME,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        customData
    );
};

export const doTagClickStartProcessButton = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'button',
        component: 'body',
        element: 'start',
        eventCategory: PAGE_NAME,
        eventAction: 'clickButton',
        eventLabel: 'startButton',
    });
};

export const doTagClickLoginButton = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'button',
        component: 'body',
        element: 'recoverProcess',
        eventCategory: PAGE_NAME,
        eventAction: 'clickButton',
        eventLabel: 'recoverProcessButton',
    });
};

export const doTagClickMoreDetailsButton = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'link',
        component: 'body',
        element: 'moreDetails',
        eventCategory: PAGE_NAME,
        eventAction: 'clickLink',
        eventLabel: 'moreDetailsLink',
    });
};

export const doTagModalDisplay = () => {
    recordEventCustomOnly({
        action: 'open',
        format: 'modal',
        component: 'modal/validDocuments',
        element: 'full',
        eventCategory: PAGE_NAME,
        eventAction: 'validDocuments',
        eventLabel: 'open',
    });
};

export const doTagModalCloseByX = () => {
    recordEventCustomOnly({
        action: 'close',
        format: 'cross',
        component: 'modal/validDocuments',
        element: 'close',
        eventCategory: PAGE_NAME,
        eventAction: 'validDocuments',
        eventLabel: 'close',
    });
};

export const doTagModalCloseByButton = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'button',
        component: 'modal/validDocuments',
        element: 'close',
        eventCategory: PAGE_NAME,
        eventAction: 'validDocuments',
        eventLabel: 'understood',
    });
};
